"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.vectorImageDataSchema = void 0;
var yup = __importStar(require("yup"));
var schemaUtils_1 = require("../schemaUtils");
var linkSchemas = __importStar(require("../link/Link.schema"));
exports.vectorImageDataSchema = schemaUtils_1.createDataSchema('VectorImage', yup.object({
    link: schemaUtils_1.createDataRef(linkSchemas).nullable(),
    alt: yup.string(),
    title: yup.string().max(100),
    svgId: yup.string(),
}));
//# sourceMappingURL=VectorImage.schema.js.map